import React from 'react';
import Lottie from 'lottie-react';

import loadingFile from './loading.json';
import * as S from './LoadingLottieElements';

export const LoadingLottie = (props: { className?: string }) => (
  <S.Wrapper className={props.className}>
    <Lottie className={'loadingLottie'} animationData={loadingFile} loop={true} />
  </S.Wrapper>
);
